import Model from './model'
import Contact from './contact'
import Company from './company'

class OrderGroup extends Model {
  static get name() {
    return 'order_groups'
  }

  static get parsers() {
    return {
      ...Model.parsers,
      customerContact: dataDict => Contact.one(dataDict),
      customerCompany: dataDict => Company.one(dataDict)
    }
  }
}

export default OrderGroup
